import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "pp_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    const size = product.size || null;
    const color = product.color || null;
    const key = `${product.id}|${size || ""}|${color || ""}`;
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: Math.min(50, i.quantity + qty) } : i));
      }
      return [
        ...prev,
        { key, product_id: product.id, name: product.name, price: product.price, image_url: product.image_url, quantity: qty, size, color },
      ];
    });
    setOpen(true);
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => (i.key || i.product_id) !== key));

  const updateQty = (key, quantity) =>
    setItems((prev) =>
      prev.map((i) => ((i.key || i.product_id) === key ? { ...i, quantity: Math.max(1, Math.min(50, quantity)) } : i)),
    );

  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    return { subtotal, count };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, open, setOpen, add, remove, updateQty, clear, totals }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
